<template>
  <div>
    <main>
      <section
        class="relative w-full h-full py-40 min-h-screen login-centerly"
        :style="`background-image: url('${registerBg2}');`"
      >
        <div class="absolute top-0 w-full h-full bg-white/70 bg-no-repeat bg-cover z-0"></div>
        <router-view />
        <!-- <footer-small absolute /> -->
      </section>
    </main>
  </div>
</template>

<script>
// import FooterSmall from "@/components/Footers/FooterSmall.vue";
import registerBg2 from "@/assets/img/bg.jpg";

export default {
  data() {
    return {
      registerBg2,
    };
  },
  components: {
    // FooterSmall,
  },
};
</script>
